import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const Grid = styled.div`
	max-width: 96rem;
	margin: 0 auto;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.75rem;
	@media (min-width: ${(props) => props.theme.viewport.medium}px) {
		grid-template-columns: repeat(4, 1fr);
	}
`;

export default function GalleryBlockZeta({ photos }: { photos: MicrositeResponsiveImage[] }) {
	if (photos.length === 0) return null;

	return (
		<Section id="gallery">
			<Grid>
				{photos.map((photo, index) => (
					<a key={index} href="#gallery" data-index={index}>
						<MicrositeResponsiveImg image={photo} priority={LoadPriority.FIRST_PAINT} />
					</a>
				))}
			</Grid>
		</Section>
	);
}
